import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: 100%;

  ${Media.Tablet`
    height: unset;
    padding: 32px 40px 94px;
  `}

  ${Media.Phone`
    gap: 32px;
    padding: 24px 16px 94px;
  `}
`

export const FontSelectContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`

export const LineHeightContainer = styled.div``

export const ContainerHeader = styled.h3`
  ${Typography.sizes.Caps};
  font-weight: ${Typography.weights.demibold};
  color: ${Colors.Neutral50};
`

export const FontSizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FontWeightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
